/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  SterWebsiteModelPriceCompareCalculateResultItem,
  SterWebsiteModelPriceCompareCalculateResultItemFromJSON,
  SterWebsiteModelPriceCompareCalculateResultItemFromJSONTyped,
  SterWebsiteModelPriceCompareCalculateResultItemToJSON,
} from "./";

/**
 *
 * @export
 * @interface SterWebsiteModelPriceCompareCalculateResult
 */
export interface SterWebsiteModelPriceCompareCalculateResult {
  /**
   *
   * @type {Array<SterWebsiteModelPriceCompareCalculateResultItem>}
   * @memberof SterWebsiteModelPriceCompareCalculateResult
   */
  targetGroups?: Array<SterWebsiteModelPriceCompareCalculateResultItem>;
  /**
   *
   * @type {Array<SterWebsiteModelPriceCompareCalculateResultItem>}
   * @memberof SterWebsiteModelPriceCompareCalculateResult
   */
  conversionGroups?: Array<SterWebsiteModelPriceCompareCalculateResultItem>;
}

export function SterWebsiteModelPriceCompareCalculateResultFromJSON(
  json: any
): SterWebsiteModelPriceCompareCalculateResult {
  return SterWebsiteModelPriceCompareCalculateResultFromJSONTyped(json, false);
}

export function SterWebsiteModelPriceCompareCalculateResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPriceCompareCalculateResult {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    targetGroups: !exists(json, "targetGroups")
      ? undefined
      : (json["targetGroups"] as Array<any>).map(
          SterWebsiteModelPriceCompareCalculateResultItemFromJSON
        ),
    conversionGroups: !exists(json, "conversionGroups")
      ? undefined
      : (json["conversionGroups"] as Array<any>).map(
          SterWebsiteModelPriceCompareCalculateResultItemFromJSON
        ),
  };
}

export function SterWebsiteModelPriceCompareCalculateResultToJSON(
  value?: SterWebsiteModelPriceCompareCalculateResult | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    targetGroups:
      value.targetGroups === undefined
        ? undefined
        : (value.targetGroups as Array<any>).map(
            SterWebsiteModelPriceCompareCalculateResultItemToJSON
          ),
    conversionGroups:
      value.conversionGroups === undefined
        ? undefined
        : (value.conversionGroups as Array<any>).map(
            SterWebsiteModelPriceCompareCalculateResultItemToJSON
          ),
  };
}
